import React from 'react';
import '../../style.css';
import {
  FaCheck,
  FaClipboardList,
  FaClock,
  FaEdit,
  FaExclamationTriangle,
} from 'react-icons/fa';

type StepStatus = 'waiting' | 'reprocessing' | 'finished' | 'active' | 'result';

export interface Step {
  label: string;
  status: StepStatus;
}

interface ProgressBreadcrumbProps {
  key: number;
  label: string;
  status: StepStatus;
  addLine: boolean;
  onClick?: () => void;
  disabled?: boolean;
  isActive: boolean;
  hidden?: boolean;
}

const statusIcons: Record<StepStatus, JSX.Element> = {
  waiting: <FaClock />,
  reprocessing: <FaExclamationTriangle />,
  finished: <FaCheck />,
  active: <FaEdit />,
  result: <FaClipboardList />,
};

const statusTooltip: Record<StepStatus, string> = {
  waiting: 'Aguardando conclusão de alguma etapa anterior',
  reprocessing:
    'Necessário reprocessamento por causa de altaração em etapa anterior',
  finished: 'Etapa concluída',
  active: 'Etapa ativa',
  result: 'Visualizar resultados',
};

export const ProgressBreadcrumb: React.FC<ProgressBreadcrumbProps> = ({
  key,
  label,
  status,
  addLine,
  disabled,
  onClick,
  isActive,
  hidden = false,
}) => {
  const isDisabled = disabled;

  return (
    // eslint-disable-next-line react/button-has-type
    <div
      role="button"
      className={`breadcrumb-step item-${
        isDisabled ? 'disabled' : 'clickable'
      }`}
      key={key}
      hidden={hidden}
      tabIndex={0}
      title={isDisabled ? 'Etapa desativada' : statusTooltip[status]}
      onClick={() => !isDisabled && onClick?.()}
      onKeyDown={e => {
        if (!isDisabled && (e.key === 'Enter' || e.key === ' ') && onClick) {
          onClick?.();
        }
      }}
    >
      <div
        className={`breadcrumb-circle item-${status} ${
          isActive ? `item-current-active` : ''
        } `}
      >
        {statusIcons[status]}
      </div>
      <div
        className={`breadcrumb-label ${isActive ? `font-current-active` : ''}`}
      >
        {label}
      </div>
      {addLine && <div className={`breadcrumb-line item-${status}`} />}
    </div>
  );
};
